import React, { useState } from 'react';
import { isValidLink } from '../../../../lib/utils';

interface ExternalLinksProps {
  externalLinks: string[];
  currentLink: string;
  onCurrentLinkChange: (value: string) => void;
  onAddLink: () => void;
  onRemoveLink: (index: number) => void;
  onInputKeyDown: (e: React.KeyboardEvent) => void;
  onInputBlur: () => void;
}

const ExternalLinks: React.FC<ExternalLinksProps> = ({
  externalLinks,
  currentLink,
  onCurrentLinkChange,
  onAddLink,
  onRemoveLink,
  onInputKeyDown,
  onInputBlur
}) => {
  const [error, setError] = useState<string>('');

  const handleBlur = () => {
    debugger;
    if (currentLink && !isValidLink(currentLink)) {
      setError('Please enter a valid link.');
    } else {
      setError('');
    }
    onInputBlur();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (!currentLink || !isValidLink(currentLink)) {
        setError('Please enter a valid link.');
        e.preventDefault();
        return;
      }
      setError('');
      onAddLink();
      e.preventDefault();
    } else {
      onInputKeyDown(e);
    }
  };

  return (
    <div className="mb-1">
      <span className="graySmallText">
        External Links
      </span>

      {/* Link Input */}
      <div className="flex gap-2 mb-3">
        <input
          type="text"
          value={currentLink}
          onChange={(e) => {
            onCurrentLinkChange(e.target.value);
            if (error) setError('');
          }}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder="Paste external document links..."
          aria-label="External link"
          className="textBody w-full border-none shadow-none outline-none"
        />
      </div>

      {error && (
        <div className="text-red-500 text mb-2">{error}</div>
      )}

      {/* Display added links as pills */}
      {externalLinks.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {externalLinks.map((link, index) => (
            <div
              key={`${link}-${index}`}
              className="inline-flex items-center coachingExternalPills "
            >
              <span className="truncate max-w-xs">{link}</span>
              <button
                onClick={() => onRemoveLink(index)}
                className="text-blue-600 hover:text-blue-800 font-bold"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExternalLinks;
